import { motion } from "framer-motion";
import { BookOpen, GraduationCap, ArrowRight } from "lucide-react";
import { BuyButton } from "./BuyButton";

const EASE = [0.22, 1, 0.36, 1];

export const EcosystemSection = ({ content }) => {
  return (
    <section id="ecosistema" className="bg-white py-16 sm:py-24" data-testid="ecosystem-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: EASE }}
          className="mx-auto mb-12 max-w-2xl text-center"
        >
          <span className="font-editorial text-sm italic tracking-wide text-terracotta">MetodoEmo</span>
          <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-olive sm:text-3xl lg:text-4xl" data-testid="ecosystem-title">
            Un ecosistema per abitare le proprie emozioni
          </h2>
          <p className="mt-3 text-base text-stone-600 sm:text-lg">
            MetodoEmo accompagna bambini e ragazzi a conoscere e raccontare ciò che provano. Due modi per iniziare: il quaderno da fare a casa, e i percorsi laboratoriali per scuole e associazioni.
          </p>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-2">
          <motion.article
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, ease: EASE }}
            className="group flex flex-col overflow-hidden rounded-3xl border border-sand bg-cream shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
            data-testid="ecosystem-book-card"
          >
            <div className="flex items-center gap-5 p-7">
              <img src={content.cover_url} alt={`Copertina di ${content.title}`} className="w-24 shrink-0 rounded-lg border border-sand shadow-md transition-transform duration-300 group-hover:-rotate-2" />
              <div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-terracotta-light px-3 py-1 text-xs font-semibold text-terracotta-dark">
                  <BookOpen className="h-3.5 w-3.5" /> Per le famiglie
                </span>
                <h3 className="mt-2 font-display text-xl font-bold text-olive sm:text-2xl">Il libro: Io Emozione</h3>
                <p className="mt-1 text-sm text-stone-600">Il quaderno operativo con 20 attività sulle emozioni, per bambini dai 6 agli 11 anni. Da fare a casa, insieme.</p>
              </div>
            </div>
            <div className="mt-auto flex flex-wrap items-center gap-3 px-7 pb-7">
              <BuyButton url={content.amazon_url} price={content.price} compact testid="ecosystem-buy-button" />
              <a href="#estratto" data-testid="ecosystem-excerpt-link" className="inline-flex items-center gap-1.5 font-display text-sm font-semibold text-olive transition-colors hover:text-terracotta">
                Sfoglia l'estratto <ArrowRight className="h-4 w-4" />
              </a>
            </div>
          </motion.article>

          <motion.article
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: 0.1, ease: EASE }}
            className="group flex flex-col overflow-hidden rounded-3xl border border-sand bg-cream shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
            data-testid="ecosystem-projects-card"
          >
            <div className="flex items-center gap-5 p-7">
              <div className="flex shrink-0 -space-x-4">
                <img src="/images/percorsi/copertina-ioemozione.jpg" alt="Percorso Io Emozione" className="h-24 w-16 rounded-lg border-2 border-white object-cover shadow-md" />
                <img src="/images/percorsi/copertina-emoproject.jpg" alt="Percorso EmoProject" className="h-24 w-16 rounded-lg border-2 border-white object-cover shadow-md" />
                <img src="/images/percorsi/copertina-sinfonie.jpg" alt="Percorso Sinfonie" className="h-24 w-16 rounded-lg border-2 border-white object-cover shadow-md" />
              </div>
              <div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-olive-light px-3 py-1 text-xs font-semibold text-olive">
                  <GraduationCap className="h-3.5 w-3.5" /> Per scuole e associazioni
                </span>
                <h3 className="mt-2 font-display text-xl font-bold text-olive sm:text-2xl">I progetti MetodoEmo</h3>
                <p className="mt-1 text-sm text-stone-600">Laboratori di educazione emotiva e mindfulness: Io Emozione (6-11), EmoProject (11-14), Sinfonie per i musicisti (13-25).</p>
              </div>
            </div>
            <div className="mt-auto flex flex-wrap items-center gap-3 px-7 pb-7">
              <a
                href="#percorsi"
                data-testid="ecosystem-projects-button"
                className="inline-flex items-center gap-2 rounded-full bg-olive px-5 py-2.5 font-display text-sm font-semibold text-white shadow-md transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg"
              >
                Scopri i percorsi <ArrowRight className="h-4 w-4" />
              </a>
              <span className="text-xs text-stone-500">Proposte su misura, senza listino online</span>
            </div>
          </motion.article>
        </div>
      </div>
    </section>
  );
};
